(() => {
  /* =========================
     Utils
  ========================== */
  const normalize = (str) =>
    (str || "")
      .toString()
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

  /* =========================
     Keywords – PT / EN / ES
  ========================== */
  const PERSONALIZAR_KEYWORDS = [
  // 🇧🇷 Português
  "personalizar",
  "sim",
  "quero",
  "inserir",
  "nome",
  "numero",
  "nome e numero",
  "nome & numero",
  "com nome",
  "com numero",

  // 🇺🇸 English (US + UK)
  "yes",
  "with name",
  "with number",
  "with name & number",
  "with name and number",
  "name & number",
  "name and number",
  "add name",
  "add number",
  "add name & number",
  "add name and number",
  "personalized",
  "personalised",
  "personalization",
  "personalisation",

  // 🇪🇸 Español
  "si",
  "sí",
  "personalizar",
  "nombre",
  "numero",
  "con nombre",
  "con numero",
  "nombre y numero"
].map(normalize);

  function matchesPersonalizar(optionValue) {
    const opt = normalize(optionValue);
    return PERSONALIZAR_KEYWORDS.some(
      (k) => opt === k || opt.includes(k)
    );
  }

  /* =========================
     Input helper (multi-idioma)
  ========================== */
  function findInput(wrapper, names) {
    return names
      .map((name) =>
        wrapper.querySelector(`input[name="properties[${name}]"]`)
      )
      .find(Boolean);
  }

  /* =========================
     Variant inicial (Dawn)
  ========================== */
  function getInitialVariantFromSection(productInfoEl) {
    const script = productInfoEl?.querySelector(
      'variant-selects script[data-selected-variant]'
    );
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  /* =========================
     Toggle Personalização
  ========================== */
  function togglePersonalizacao(wrapper, variant) {
    if (!wrapper) return;

    const nomeInput = findInput(wrapper, ["Nome", "Name", "Nombre"]);
    const numeroInput = findInput(wrapper, ["Número", "Number", "Numero"]);

    const options = Array.isArray(variant?.options)
      ? variant.options
      : [];

    const hasPersonalizar = options.some(matchesPersonalizar);

    if (hasPersonalizar) {
      wrapper.classList.remove("hidden");
      if (nomeInput) nomeInput.disabled = false;
      if (numeroInput) numeroInput.disabled = false;
    } else {
      wrapper.classList.add("hidden");

      if (nomeInput) {
        nomeInput.value = "";
        nomeInput.disabled = true;
      }

      if (numeroInput) {
        numeroInput.value = "";
        numeroInput.disabled = true;
      }
    }
  }

  /* =========================
     Init por product-info
  ========================== */
  function initPersonalizacaoForProductInfo(productInfoEl) {
    const sectionId = productInfoEl?.dataset?.section;
    if (!sectionId) return;

    const wrapper = productInfoEl.querySelector(
      `[data-personalizacao-wrapper][data-section-id="${sectionId}"]`
    );
    if (!wrapper) return;

    // Estado inicial
    const initialVariant = getInitialVariantFromSection(productInfoEl);
    togglePersonalizacao(wrapper, initialVariant);

    // Mudança de variante (Dawn PubSub)
    if (
      typeof subscribe === "function" &&
      typeof PUB_SUB_EVENTS !== "undefined"
    ) {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const data = event?.data;
        if (!data || data.sectionId !== sectionId) return;
        togglePersonalizacao(wrapper, data.variant);
      });
    }
  }

  /* =========================
     DOM Ready
  ========================== */
  document.addEventListener("DOMContentLoaded", () => {
    document
      .querySelectorAll("product-info")
      .forEach(initPersonalizacaoForProductInfo);
  });
})();